import { admin_areaAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import dayjs from 'dayjs';
import store from '@/store';

export default {
  fetchAreaPoints: async ({ commit }, storeNo) => {
    const { status, data } = await ServiceExec.get(
      admin_areaAPI.points(storeNo)
    );
    if (status === 200) commit('setAreaPoints', data);
  }
};
